import { Table as TableUI } from '@mantine/core';
import { useContext } from 'react';
import TableHeader from './_parts/TableHeader/TableHeader';
import TableRow from './_parts/TableRow/TableRow';
import TableTop from './_parts/TableTop/TableTop';
import { TableContext, TableProvider } from './Table.context';
import { Wrapper } from './Table.style';
import TableEmpty from './TableEmpty/TableEmpty';
import TableLoading from './TableLoading/TableLoading';

export type TableProps = {
  config: ITableConfig;
  items: IModel[];
  onAction: OnAction;
  isLoading?: boolean;
};

export function TableInner() {
  const { data } = useContext(TableContext);

  function renderRow(rowData: IModel) {
    return <TableRow key={rowData.id} rowData={rowData} />;
  }

  function renderRows() {
    return data.map((rowData: IModel) => renderRow(rowData));
  }

  function renderTable() {
    if (data.length === 0) {
      return <TableEmpty />;
    }

    return (
      <TableUI>
        <TableHeader />
        <TableUI.Tbody>{renderRows()}</TableUI.Tbody>
      </TableUI>
    );
  }

  return (
    <Wrapper className='Table-wrapper' data-testid='Table-wrapper'>
      <TableTop />
      {renderTable()}
    </Wrapper>
  );
}

export function Table(props: TableProps) {
  const { config, items, isLoading } = props;

  if (isLoading) {
    return <TableLoading />;
  }

  return (
    <TableProvider config={config} data={items} onAction={props.onAction}>
      <TableInner />
    </TableProvider>
  );
}

export default Table;
